$.fn.PostShare = function() {
  let self = this

  if (self.data('post-share')) {
    return self.data('post-share')
  }

  self.copy_link = function() {
    self.find('.post-share__action--copy-link').width(self.find('.post-share__action--copy-link').width())
    self.find('textarea').val(window.location.href).focus().select()
    document.execCommand("Copy")
    self.find('.post-share__action--copy-link span').text(stisidore_l10n.COPIED_LINK)
    return false
  }

  self.toggled = function() {
    if (self.attr('aria-expanded') && self.attr('aria-expanded') == 'false') {
      self.attr('aria-expanded', 'true')
    } else if (self.attr('aria-expanded') && self.attr('aria-expanded') == 'true') {
      self.attr('aria-expanded', 'false')
    }
  }

  return function() {
    self.find('.post-share__button').on('click', self.toggled)
    self.find('.post-share__action--copy-link').on('click', self.copy_link)
    self.data('post-share', self)
    return self
  }()
}
